// Generated S layer lookup table
// Contains flattened taxonomy for Stars

export const S_LAYER_LOOKUP = {
  POP: {
    numericCode: '001',
    name: 'Pop',
  },
  'POP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'POP.DIV': {
    numericCode: '002',
    name: 'Pop_Diva_Female_Stars',
  },
  'POP.IDF': {
    numericCode: '003',
    name: 'Pop_Idol_Female_Stars',
  },
  'POP.LGF': {
    numericCode: '004',
    name: 'Pop_Legend_Female_Stars',
  },
  'POP.LGM': {
    numericCode: '005',
    name: 'Pop_Legend_Male_Stars',
  },
  'POP.ICM': {
    numericCode: '006',
    name: 'Pop_Icon_Male_Stars',
  },
  'POP.HPM': {
    numericCode: '007',
    name: 'Pop_Hipster_Male_Stars',
  },
  'POP.GLB': {
    numericCode: '008',
    name: 'Global',
  },
  'POP.TEN': {
    numericCode: '009',
    name: 'Teen',
  },
  'POP.DNC': {
    numericCode: '010',
    name: 'Dance',
  },
  'POP.ELC': {
    numericCode: '011',
    name: 'Electro',
  },
  'POP.DRM': {
    numericCode: '012',
    name: 'Dream',
  },
  'POP.IND': {
    numericCode: '013',
    name: 'Indie',
  },
  'POP.SOU': {
    numericCode: '014',
    name: 'Soul',
  },
  'POP.PNK': {
    numericCode: '015',
    name: 'Punk',
  },
  'POP.IDP': {
    numericCode: '016',
    name: 'Idol_Pop',
  },
  RCK: {
    numericCode: '002',
    name: 'Rock',
  },
  'RCK.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RCK.RSF': {
    numericCode: '002',
    name: 'Rock_Star_Female_Stars',
  },
  'RCK.RSM': {
    numericCode: '003',
    name: 'Rock_Star_Male_Stars',
  },
  'RCK.CLS': {
    numericCode: '004',
    name: 'Classic',
  },
  'RCK.MOD': {
    numericCode: '005',
    name: 'Modern',
  },
  'RCK.MTL': {
    numericCode: '006',
    name: 'Metal',
  },
  'RCK.PNK': {
    numericCode: '007',
    name: 'Punk',
  },
  'RCK.ALT': {
    numericCode: '008',
    name: 'Alternative',
  },
  'RCK.GRG': {
    numericCode: '009',
    name: 'Grunge',
  },
  'RCK.PRG': {
    numericCode: '010',
    name: 'Progressive',
  },
  'RCK.IND': {
    numericCode: '011',
    name: 'Indie',
  },
  'RCK.PSY': {
    numericCode: '012',
    name: 'Psychedelic',
  },
  'RCK.BLU': {
    numericCode: '013',
    name: 'Blues',
  },
  HIP: {
    numericCode: '003',
    name: 'Hip_Hop',
  },
  'HIP.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'HIP.HPF': {
    numericCode: '002',
    name: 'Hip_Hop_Female_Stars',
  },
  'HIP.RAP': {
    numericCode: '003',
    name: 'Rap',
  },
  'HIP.TRP': {
    numericCode: '004',
    name: 'Trap',
  },
  'HIP.MCS': {
    numericCode: '005',
    name: 'MC',
  },
  'HIP.DRL': {
    numericCode: '006',
    name: 'Drill',
  },
  'HIP.PRD': {
    numericCode: '007',
    name: 'Producer',
  },
  'HIP.MUM': {
    numericCode: '008',
    name: 'Mumble',
  },
  RNB: {
    numericCode: '004',
    name: 'RnB',
  },
  'RNB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RNB.SOU': {
    numericCode: '002',
    name: 'Soul',
  },
  'RNB.MOD': {
    numericCode: '003',
    name: 'Modern',
  },
  'RNB.NEO': {
    numericCode: '004',
    name: 'Neo_Soul',
  },
  'RNB.GOS': {
    numericCode: '005',
    name: 'Gospel',
  },
  'RNB.BLU': {
    numericCode: '006',
    name: 'Blues',
  },
  'RNB.FNK': {
    numericCode: '007',
    name: 'Funk',
  },
  'RNB.JSU': {
    numericCode: '008',
    name: 'Jazz_Soul',
  },
  'RNB.URB': {
    numericCode: '009',
    name: 'Urban',
  },
  'RNB.ALT': {
    numericCode: '010',
    name: 'Alternative',
  },
  'RNB.FSU': {
    numericCode: '011',
    name: 'Future_Soul',
  },
  DNC: {
    numericCode: '005',
    name: 'Dance_Electronic',
  },
  'DNC.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'DNC.PRD': {
    numericCode: '002',
    name: 'Producer',
  },
  'DNC.HSE': {
    numericCode: '003',
    name: 'House',
  },
  'DNC.TEC': {
    numericCode: '004',
    name: 'Techno',
  },
  'DNC.TRN': {
    numericCode: '005',
    name: 'Trance',
  },
  'DNC.DUB': {
    numericCode: '006',
    name: 'Dubstep',
  },
  'DNC.FUT': {
    numericCode: '007',
    name: 'Future',
  },
  'DNC.DNB': {
    numericCode: '008',
    name: 'DnB',
  },
  'DNC.AMB': {
    numericCode: '009',
    name: 'Ambient',
  },
  'DNC.LIV': {
    numericCode: '010',
    name: 'Live',
  },
  'DNC.EXP': {
    numericCode: '011',
    name: 'Experimental',
  },
  LAT: {
    numericCode: '006',
    name: 'Latin',
  },
  'LAT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'LAT.REG': {
    numericCode: '002',
    name: 'Reggaeton',
  },
  'LAT.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'LAT.SAL': {
    numericCode: '004',
    name: 'Salsa',
  },
  'LAT.BCH': {
    numericCode: '005',
    name: 'Bachata',
  },
  'LAT.RCK': {
    numericCode: '006',
    name: 'Rock',
  },
  'LAT.TRP': {
    numericCode: '007',
    name: 'Trap',
  },
  'LAT.MER': {
    numericCode: '008',
    name: 'Merengue',
  },
  'LAT.JZZ': {
    numericCode: '009',
    name: 'Jazz',
  },
  'LAT.CUM': {
    numericCode: '010',
    name: 'Cumbia',
  },
  'LAT.FLM': {
    numericCode: '011',
    name: 'Flamenco',
  },
  IND: {
    numericCode: '007',
    name: 'Indie',
  },
  'IND.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'IND.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'IND.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'IND.FLK': {
    numericCode: '004',
    name: 'Folk',
  },
  'IND.ELC': {
    numericCode: '005',
    name: 'Electronic',
  },
  'IND.HIP': {
    numericCode: '006',
    name: 'Hip_Hop',
  },
  'IND.DRM': {
    numericCode: '007',
    name: 'Dream',
  },
  'IND.LOF': {
    numericCode: '008',
    name: 'Lo_Fi',
  },
  'IND.ART': {
    numericCode: '009',
    name: 'Art',
  },
  'IND.PST': {
    numericCode: '010',
    name: 'Post',
  },
  ALT: {
    numericCode: '008',
    name: 'Alternative',
  },
  'ALT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'ALT.RCK': {
    numericCode: '002',
    name: 'Rock',
  },
  'ALT.POP': {
    numericCode: '003',
    name: 'Pop',
  },
  'ALT.EXP': {
    numericCode: '004',
    name: 'Experimental',
  },
  'ALT.DRK': {
    numericCode: '005',
    name: 'Dark',
  },
  'ALT.MTL': {
    numericCode: '006',
    name: 'Metal',
  },
  'ALT.IND': {
    numericCode: '007',
    name: 'Industrial',
  },
  'ALT.ART': {
    numericCode: '008',
    name: 'Art',
  },
  'ALT.NOI': {
    numericCode: '009',
    name: 'Noise',
  },
  'ALT.PST': {
    numericCode: '010',
    name: 'Post',
  },
  'ALT.SHG': {
    numericCode: '011',
    name: 'Shoegaze',
  },
  WLD: {
    numericCode: '009',
    name: 'World',
  },
  'WLD.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'WLD.FUS': {
    numericCode: '002',
    name: 'Fusion',
  },
  'WLD.AFR': {
    numericCode: '003',
    name: 'African',
  },
  'WLD.IND': {
    numericCode: '004',
    name: 'Indian',
  },
  'WLD.MDE': {
    numericCode: '005',
    name: 'Middle_East',
  },
  'WLD.CEL': {
    numericCode: '006',
    name: 'Celtic',
  },
  'WLD.REG': {
    numericCode: '007',
    name: 'Reggae',
  },
  'WLD.ASN': {
    numericCode: '008',
    name: 'Asian',
  },
  'WLD.BAL': {
    numericCode: '009',
    name: 'Balkan',
  },
  'WLD.MED': {
    numericCode: '010',
    name: 'Mediterranean',
  },
  'WLD.GLB': {
    numericCode: '011',
    name: 'Global',
  },
  JZZ: {
    numericCode: '010',
    name: 'Jazz',
  },
  'JZZ.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JZZ.CON': {
    numericCode: '002',
    name: 'Contemporary',
  },
  'JZZ.TRD': {
    numericCode: '003',
    name: 'Traditional',
  },
  'JZZ.SMO': {
    numericCode: '004',
    name: 'Smooth',
  },
  'JZZ.EXP': {
    numericCode: '005',
    name: 'Experimental',
  },
  'JZZ.LAT': {
    numericCode: '006',
    name: 'Latin',
  },
  'JZZ.WLD': {
    numericCode: '007',
    name: 'World',
  },
  JPO: {
    numericCode: '011',
    name: 'J_Pop',
  },
  'JPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'JPO.POP': {
    numericCode: '002',
    name: 'Pop',
  },
  'JPO.RKF': {
    numericCode: '003',
    name: 'Rock_Fusion',
  },
  'JPO.ANI': {
    numericCode: '004',
    name: 'Anime_Music',
  },
  'JPO.ELC': {
    numericCode: '005',
    name: 'Electronic',
  },
  'JPO.KAW': {
    numericCode: '006',
    name: 'Kawaii',
  },
  'JPO.ALT': {
    numericCode: '007',
    name: 'Alternative',
  },
  'JPO.TRD': {
    numericCode: '008',
    name: 'Traditional',
  },
  'JPO.DNC': {
    numericCode: '009',
    name: 'Dance',
  },
  'JPO.RET': {
    numericCode: '010',
    name: 'Retro',
  },
  'JPO.ACO': {
    numericCode: '011',
    name: 'Acoustic',
  },
  BOL: {
    numericCode: '012',
    name: 'Bollywood',
  },
  'BOL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'BOL.PLB': {
    numericCode: '002',
    name: 'Playback',
  },
  'BOL.PFU': {
    numericCode: '003',
    name: 'Pop_Fusion',
  },
  'BOL.CLS': {
    numericCode: '004',
    name: 'Classical',
  },
  'BOL.DNC': {
    numericCode: '005',
    name: 'Dance',
  },
  'BOL.IFU': {
    numericCode: '006',
    name: 'Indie_Fusion',
  },
  'BOL.ELC': {
    numericCode: '007',
    name: 'Electronic',
  },
  'BOL.FLK': {
    numericCode: '008',
    name: 'Folk',
  },
  'BOL.SFI': {
    numericCode: '009',
    name: 'Sufi',
  },
  'BOL.RMX': {
    numericCode: '010',
    name: 'Remix',
  },
  'BOL.GLB': {
    numericCode: '011',
    name: 'Global',
  },
  KPO: {
    numericCode: '013',
    name: 'K_Pop',
  },
  'KPO.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'KPO.IBG': {
    numericCode: '002',
    name: 'Idol_Boy_Group',
  },
  'KPO.IGG': {
    numericCode: '003',
    name: 'Idol_Girl_Group',
  },
  'KPO.SFS': {
    numericCode: '004',
    name: 'Solo_Female_Star',
  },
  'KPO.SMS': {
    numericCode: '005',
    name: 'Solo_Male_Star',
  },
  'KPO.RAP': {
    numericCode: '006',
    name: 'Rapper',
  },
  'KPO.DNL': {
    numericCode: '007',
    name: 'Dance_Leader',
  },
  'KPO.VIS': {
    numericCode: '008',
    name: 'Visual',
  },
  'KPO.VOC': {
    numericCode: '009',
    name: 'Vocalist',
  },
  'KPO.MAK': {
    numericCode: '010',
    name: 'Maknae',
  },
  VAV: {
    numericCode: '014',
    name: 'Virtual_Avatars',
  },
  'VAV.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'VAV.AIG': {
    numericCode: '002',
    name: 'AI_Generated_Star',
  },
  'VAV.VTB': {
    numericCode: '003',
    name: 'VTuber',
  },
  'VAV.MTA': {
    numericCode: '004',
    name: 'Metaverse_Avatar',
  },
  'VAV.CRT': {
    numericCode: '005',
    name: 'Cartoon_Star',
  },
  'VAV.FAN': {
    numericCode: '006',
    name: 'Fantasy_Character',
  },
  'VAV.RBT': {
    numericCode: '007',
    name: 'Robot_Singer',
  },
  'VAV.PIX': {
    numericCode: '008',
    name: 'Pixel_Art_Star',
  },
  CUL: {
    numericCode: '015',
    name: 'Cultural_Icons',
  },
  'CUL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CUL.AFB': {
    numericCode: '002',
    name: 'Afrobeats_Star',
  },
  'CUL.BOL': {
    numericCode: '003',
    name: 'Bollywood_Legend',
  },
  'CUL.LAT': {
    numericCode: '004',
    name: 'Latin_Sensation',
  },
  'CUL.JPO': {
    numericCode: '005',
    name: 'JPop_Celebrity',
  },
  'CUL.REG': {
    numericCode: '006',
    name: 'Reggaeton_Artist',
  },
  'CUL.KAW': {
    numericCode: '007',
    name: 'Kawaii_Idol',
  },
  'CUL.DES': {
    numericCode: '008',
    name: 'Desi_Star',
  },
  'CUL.CPO': {
    numericCode: '009',
    name: 'Chinese_Pop_Icon',
  },
  FAN: {
    numericCode: '016',
    name: 'Fantasy',
  },
  'FAN.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FAN.ELF': {
    numericCode: '002',
    name: 'Elven_Star',
  },
  'FAN.MGC': {
    numericCode: '003',
    name: 'Magical_Star',
  },
  'FAN.DRG': {
    numericCode: '004',
    name: 'Dragon_Warrior',
  },
};

export const S_SUBCATEGORIES = {
  POP: [
    'POP.BAS',
    'POP.DIV',
    'POP.IDF',
    'POP.LGF',
    'POP.LGM',
    'POP.ICM',
    'POP.HPM',
    'POP.GLB',
    'POP.TEN',
    'POP.DNC',
    'POP.ELC',
    'POP.DRM',
    'POP.IND',
    'POP.SOU',
    'POP.PNK',
    'POP.IDP',
  ],
  RCK: [
    'RCK.BAS',
    'RCK.RSF',
    'RCK.RSM',
    'RCK.CLS',
    'RCK.MOD',
    'RCK.MTL',
    'RCK.PNK',
    'RCK.ALT',
    'RCK.GRG',
    'RCK.PRG',
    'RCK.IND',
    'RCK.PSY',
    'RCK.BLU',
  ],
  HIP: [
    'HIP.BAS',
    'HIP.HPF',
    'HIP.RAP',
    'HIP.TRP',
    'HIP.MCS',
    'HIP.DRL',
    'HIP.PRD',
    'HIP.MUM',
  ],
  RNB: [
    'RNB.BAS',
    'RNB.SOU',
    'RNB.MOD',
    'RNB.NEO',
    'RNB.GOS',
    'RNB.BLU',
    'RNB.FNK',
    'RNB.JSU',
    'RNB.URB',
    'RNB.ALT',
    'RNB.FSU',
  ],
  DNC: [
    'DNC.BAS',
    'DNC.PRD',
    'DNC.HSE',
    'DNC.TEC',
    'DNC.TRN',
    'DNC.DUB',
    'DNC.FUT',
    'DNC.DNB',
    'DNC.AMB',
    'DNC.LIV',
    'DNC.EXP',
  ],
  LAT: [
    'LAT.BAS',
    'LAT.REG',
    'LAT.POP',
    'LAT.SAL',
    'LAT.BCH',
    'LAT.RCK',
    'LAT.TRP',
    'LAT.MER',
    'LAT.JZZ',
    'LAT.CUM',
    'LAT.FLM',
  ],
  IND: [
    'IND.BAS',
    'IND.RCK',
    'IND.POP',
    'IND.FLK',
    'IND.ELC',
    'IND.HIP',
    'IND.DRM',
    'IND.LOF',
    'IND.ART',
    'IND.PST',
  ],
  ALT: [
    'ALT.BAS',
    'ALT.RCK',
    'ALT.POP',
    'ALT.EXP',
    'ALT.DRK',
    'ALT.MTL',
    'ALT.IND',
    'ALT.ART',
    'ALT.NOI',
    'ALT.PST',
    'ALT.SHG',
  ],
  WLD: [
    'WLD.BAS',
    'WLD.FUS',
    'WLD.AFR',
    'WLD.IND',
    'WLD.MDE',
    'WLD.CEL',
    'WLD.REG',
    'WLD.ASN',
    'WLD.BAL',
    'WLD.MED',
    'WLD.GLB',
  ],
  JZZ: [
    'JZZ.BAS',
    'JZZ.CON',
    'JZZ.TRD',
    'JZZ.SMO',
    'JZZ.EXP',
    'JZZ.LAT',
    'JZZ.WLD',
  ],
  JPO: [
    'JPO.BAS',
    'JPO.POP',
    'JPO.RKF',
    'JPO.ANI',
    'JPO.ELC',
    'JPO.KAW',
    'JPO.ALT',
    'JPO.TRD',
    'JPO.DNC',
    'JPO.RET',
    'JPO.ACO',
  ],
  BOL: [
    'BOL.BAS',
    'BOL.PLB',
    'BOL.PFU',
    'BOL.CLS',
    'BOL.DNC',
    'BOL.IFU',
    'BOL.ELC',
    'BOL.FLK',
    'BOL.SFI',
    'BOL.RMX',
    'BOL.GLB',
  ],
  KPO: [
    'KPO.BAS',
    'KPO.IBG',
    'KPO.IGG',
    'KPO.SFS',
    'KPO.SMS',
    'KPO.RAP',
    'KPO.DNL',
    'KPO.VIS',
    'KPO.VOC',
    'KPO.MAK',
  ],
  VAV: [
    'VAV.BAS',
    'VAV.AIG',
    'VAV.VTB',
    'VAV.MTA',
    'VAV.CRT',
    'VAV.FAN',
    'VAV.RBT',
    'VAV.PIX',
  ],
  CUL: [
    'CUL.BAS',
    'CUL.AFB',
    'CUL.BOL',
    'CUL.LAT',
    'CUL.JPO',
    'CUL.REG',
    'CUL.KAW',
    'CUL.DES',
    'CUL.CPO',
  ],
  FAN: ['FAN.BAS', 'FAN.ELF', 'FAN.MGC', 'FAN.DRG'],
};
